import { useState } from 'react';
import { apiURL } from '../../../consts/URLs';
import { LOGIN } from '../../endpointList';
import { fetchRequest, getOptions } from '../../utils';

interface Login {
    email: string;
    password: string;
}

const useLogin = () => {
    const [loginResponse, setResponse] = useState<any>();
    const [loginResult, setResult] = useState<any>();

    const login = (obj: Login) => {
        const url = `${apiURL}/${LOGIN}?email=${obj.email}&password=${obj.password}`;
        const options = getOptions({ method: 'POST' });
        fetchRequest(url, options, setResponse, setResult);
    };

    return { loginResponse, loginResult, login };
};
export default useLogin;
